import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CreateEventEffects } from './create-event-form.effects';

@NgModule({
  imports: [EffectsModule.forFeature([CreateEventEffects])]
})
export class EventsCreateEventLazyModule {}
